import { Outlet, RouteObject, useNavigate, useSearchParams } from 'react-router'
import React from 'react'
import { PageLayout } from '@/common/layouts/PageLayout.tsx'
import Title from 'antd/es/typography/Title'
import { Button, Flex, Tabs, TabsProps, Typography } from 'antd'
import { LinkButton } from '@/common/components/LinkButton.tsx'
import { ContractRegionConfigProvider } from '@/pages/document-autofill/hooks/useContractRegionConfig.tsx'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { routes } from '@/utils/routes.ts'
import { documentAutofillNavConfig } from '@/pages/document-autofill/documentAutofillNavConfig.tsx'


const BackButton: React.FC<{ tab: string }> = ({ tab }) => {
  const navigate = useNavigate()
  return <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(`${routes.documentAutofillList}?tab=${tab}`)} />
}

const documentAutofillCountryRoutes: RouteObject[] = documentAutofillNavConfig.map(countryGp => {
  return {
    path: countryGp.pathValue,
    element: (
      <PageLayout>
        <ContractRegionConfigProvider region={countryGp.region}>
          <BackButton tab={countryGp.pathValue} />
          <Outlet />
        </ContractRegionConfigProvider>
      </PageLayout>
    ),
    children: countryGp.subGroups.map(subGp => {
      return subGp.children.map(leaf => {
        return {
          path: `${subGp.pathValue}/${leaf.pathValue}`,
          element: leaf.element,
        } as RouteObject
      })
    }).flat(),
  } as RouteObject
})

const tabItems: TabsProps['items'] = documentAutofillNavConfig.map(countryCfg => {
  return {
    key: countryCfg.pathValue,
    label: countryCfg.label,
    children: (
      <Flex vertical gap="large">
        {countryCfg.subGroups.map(subGroup => {
          const groupPath = `${countryCfg.pathValue}/${subGroup.pathValue}`
          return (
            <Flex vertical gap="small" key={groupPath}>
              <Typography.Title level={5}>{subGroup.label}</Typography.Title>
              <Flex gap="middle" key={groupPath} wrap="wrap">
                {subGroup.children.map(node => {
                  return (
                    <LinkButton
                      key={node.pathValue}
                      value={node.label}
                      href={`${groupPath}/${node.pathValue}`}
                      type="default"
                    />
                  )
                })}
              </Flex>
            </Flex>
          )
        })}
      </Flex>
    ),
  }
})

const DocumentAutofillPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const activeKey = searchParams.get('tab') || tabItems[0].key

  const handleTabChange = (key: string) => {
    setSearchParams(prev => ({ ...prev, tab: key }))
  }

  return (
    <PageLayout>
      <Flex vertical gap="small">
        <Title level={2}>Document Autofill</Title>
        <Tabs
          items={tabItems}
          activeKey={activeKey}
          onChange={handleTabChange}
        />
      </Flex>
    </PageLayout>
  )
}

export const documentAutofillRoutes: RouteObject = {
  path: 'document-autofill',
  element: <Outlet />,
  children: [
    { index: true, element: <DocumentAutofillPage /> },
    ...documentAutofillCountryRoutes,
  ],
}